<template>
    <div id="container">
                

        <DiceRoller  :isLastStand="isLastStand" ref="UsComponent" title="Us" :noOfDice="ourDice" :isThem="false"/>

        <DiceRoller :style="{opacity:hopeAvailable? 1 : 0}" :isLastStand="isLastStand" ref="HopeComponent" title="Hope" :noOfDice="1" :isThem="false"/>
        
        <DiceRoller  :isLastStand="isLastStand" ref="ThemComponent" title="Them" :noOfDice="theirDice + theirBaseDice" :isThem="true"/>
    </div>
</template>

<script>
import DiceRoller from './DiceRoller.vue';
import { usePlayerStore } from '../store/usePlayerStore';
import { storeToRefs } from 'pinia';

export default {
  name: 'DiceComponent',
  components:{
      DiceRoller,
  },

    setup(){
        const playerStore = usePlayerStore()
        const { hopeAvailable } = storeToRefs(playerStore)
        return {
            hopeAvailable
        }
    },

  props:{
      candles: Number,
      isLastStand: Boolean,
  },
  emits:['bolsterThem','returnDie'],
  data() {
      return {
          theirDice: 0,
          theirBaseDice: 10-this.candles,
          ourDice: this.candles,

      }
  },
  methods: {
      bolsterThem(n = 0) {
          console.log(n)
          this.theirDice += n;
      },
      returnDice(){
          this.ourDice = this.candles;
          this.$refs.UsComponent.resetDice(this.ourDice);
          this.theirBaseDice = 10 - this.candles;
          this.theirDice = 0;
      },
      progressDarkness(candles) {
          this.ourDice = candles;
          this.$refs.UsComponent.resetDice(this.ourDice);
          this.theirBaseDice = 10 - candles;
          this.theirDice = 0;
      }
  }
}
</script>

<style scoped>
    #container {
        flex: 4;
        align-items: center;
        justify-content: center;
        display:flex;
        border-width: 0pt;
        border-style: solid;
        border-color: orangered;
        justify-content: space-evenly;

    }
</style>